import React from 'react';
import { useInView } from 'react-intersection-observer';
import { GatsbyImage, getImage, withArtDirection, ImageDataLike, StaticImage } from 'gatsby-plugin-image'
import {Heading} from 'components/Heading';
import {CallToAction} from 'components/CallToAction';
import LottieAnimation from 'components/LottieAnimation';
import { heading, section } from '../classes'
import { prepareData } from 'utils/googleData'


    export default function ComponentBased(props) {
      const {
          enable,
          title,
          subtitle,
          video,
          lottie,
          description,
          cta,
          direction,
          style,
          animationData,
          gatsbyImage,
          features,
          gatsbyTransformed
      } = prepareData({ props })
      if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
          return <></>
      }
  const [animationWrapperRef, isAnimationWrapperInView] = useInView({
    triggerOnce: true,
    threshold: 0.6,
  });
console.log('animationData', animationData)
  const lottieData = {
    lottieOptions: {
      animationData,
    },
    isInView: isAnimationWrapperInView,
  };

  return (
    <section className="lg:py-12 md:py-12 py-12">
      <div className="container md:grid-gap-x md:grid md:grid-cols-12 items-center flex flex-col">
        <div className="md:col-start-1 md:col-end-5 xl:col-end-6 text-center">
          <Heading
            size="xl"
            tag="h2"
            className="leading-tight lg:text-4xl text-3xl"
            theme="white"
          >
            {title}
          </Heading>
          <p className="mt-5 text-lg font-book leading-snug text-primary dark:text-white lg:mt-3 lg:text-base">
            {subtitle}
          </p>
          <CallToAction size = 'sm' type="primary" width="56" to={cta?.url}>
          {cta?.label}
                </CallToAction>
        </div>

        <div
          className="relative md:col-start-6 md:col-end-13 lg:col-start-6 md:mt-11 md:w-full mt-8"
          ref={animationWrapperRef}
        >
          <LottieAnimation className="absolute top-0 left-0 h-full w-full" {...lottieData} />
        </div>
      </div>
    </section>
  );
};

